import { useEffect } from "react";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@shared/components/ui/Toast";
import { useToaster } from "@shared/hooks/useToaster";

// Set by the support, debug, demo and appointment debug drawers.
type DrawerWindow = Window & {
  hideSupport?: () => void;
  hideDebug?: () => void;
  hideDemo?: () => void;
  hideAppointmentDebug?: () => void;
  showSupport?: () => void;
  showDebug?: () => void;
  showDemo?: () => void;
  showAppointmentDebug?: () => void;
};

export const Toaster = () => {
  const { toasts, hasToastDisplayed } = useToaster();

  useEffect(() => {
    // Hide/Show the Zendesk widget when a toast is displayed
    if (hasToastDisplayed) {
      (window as DrawerWindow).hideSupport?.();
      (window as DrawerWindow).hideDebug?.();
      (window as DrawerWindow).hideDemo?.();
      (window as DrawerWindow).hideAppointmentDebug?.();
    } else {
      (window as DrawerWindow).showSupport?.();
      (window as DrawerWindow).showDebug?.();
      (window as DrawerWindow).showDemo?.();
      (window as DrawerWindow).showAppointmentDebug?.();
    }
  }, [hasToastDisplayed]);

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
};
